import React from 'react';
import datascient from './datascient.svg';

export const tagline = ({ sx }) => {
  return (
    <div style={{ color: 'rgb(120, 166, 216)', fontSize: '30px', alignItems: 'center', textAlign: 'center', ...sx }}>
      Hire talent 10x faster using <img src={datascient} alt='Datascient.ai' style={{ height: '25px', textAlign: 'center' }} />
    </div>
  );
}

export default tagline;
